import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { Reveal, Overline } from "../components/Motion";
import { EstimateSection } from "../components/Sections";
import { PageHero } from "./ServicePage";
import { Seo, crumbsLd } from "../components/Seo";
import { BIZ, SERVICES, STORM } from "../data/site";
import { TOWNS } from "../data/areas";

const TownCard = ({ t, i }) => (
  <Reveal delay={(i % 3) * 0.06}>
    <div className="flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-6 transition-shadow hover:shadow-lg" data-testid={`town-card-${t.slug}`}>
      <Link to={`/service-areas/${t.slug}`} className="group flex items-start justify-between gap-3" data-testid={`town-link-${t.slug}`}>
        <span>
          <span className="font-display block text-3xl font-black uppercase text-slate-900">{t.name}, WI</span>
          <span className="text-xs font-semibold uppercase tracking-widest text-slate-500">{t.county} County · {t.zips.slice(0, 3).join(", ")}</span>
        </span>
        <ArrowRight className="mt-2 h-5 w-5 shrink-0 text-slate-900 transition-transform group-hover:translate-x-1" />
      </Link>
      {t.busy && <span className="mt-3 w-fit rounded-full bg-slate-900 px-3 py-1 text-xs font-semibold text-white">Most-requested roofing area</span>}
      <div className="mt-5 flex flex-wrap gap-2">
        {[...SERVICES, STORM].map((s) => (
          <Link key={s.slug} to={`/${s.slug}/${t.slug}`} className="rounded-full border border-slate-300 px-3 py-1.5 text-sm font-semibold text-slate-700 hover:border-slate-900" data-testid={`town-${t.slug}-${s.slug}`}>
            {s.title} in {t.name}
          </Link>
        ))}
      </div>
    </div>
  </Reveal>
);

export default function ServiceAreasPage() {
  return (
    <main data-testid="service-areas-page">
      <Seo title="Roofer, Siding & Gutter Contractor Service Areas | Good Home Improvement"
        description={`Roofing, siding, gutters and storm damage repair in Menomonee Falls, Brown Deer, Oak Creek, Wauwatosa, Brookfield, Waukesha, Mequon, Franklin & more. Call ${BIZ.phone}.`}
        path="/service-areas" jsonld={{ "@context": "https://schema.org", ...crumbsLd([["Home", "/"], ["Service areas", "/service-areas"]]) }} />
      <PageHero img={SERVICES[0].img} crumb="Service areas" kicker="Roofer near me · SE Wisconsin" lines={["Roofing near", <span key="y" className="text-amber-400">you.</span>]}
        sub="Local roofing, siding and gutter crews serving Milwaukee and Waukesha County homeowners. Pick your town below." testid="service-areas-hero" />
      <section className="bg-slate-50 py-20 md:py-28">
        <div className="wrap">
          <Reveal><Overline>Towns we serve</Overline>
            <h2 className="font-display text-4xl font-black uppercase leading-[0.9] text-slate-900 md:text-6xl">Find your town</h2>
            <p className="mt-4 max-w-2xl text-slate-600">Don't see your town? We also work in nearby communities across southeastern Wisconsin. Call {BIZ.phone} and ask.</p></Reveal>
          <div className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            {TOWNS.map((t, i) => <TownCard key={t.slug} t={t} i={i} />)}
          </div>
          <p className="mt-10 flex items-center gap-2 text-sm text-slate-500"><MapPin className="h-4 w-4" /> Office: {BIZ.address}</p>
        </div>
      </section>
      <EstimateSection />
    </main>
  );
}
